import { Controller } from "@hotwired/stimulus"
import Tooltip from 'bootstrap/js/dist/tooltip';

export default class extends Controller {
  static values = {
    title: String,
    show: Boolean
  }

  connect() {
    this.tooltip = new Tooltip(this.element, {
      title: this.titleValue
    });
    this.element.style.whiteSpace = 'nowrap';
    if (this.showValue) {
      this.tooltip.show();
    }
  }
}
